import AdminLayout from "layouts/AdminLayout";
import ChangePassword from "pages/register/ChangePassword";
import DefaultLayout from "layouts/DefaultLayout";
import Timesheet from "pages/timesheet";
import UploadCsv from "pages/uploadcsv";
import React, { Suspense } from "react";
import { BrowserRouter as Router, Routes } from "react-router-dom";
import { Route } from "react-router-dom";
import DrawerExample from "../components/Drawer/Sample";
import Sidebar from "../components/SideBar";
import Login from "../pages/Login";
import ForgotPassword from "pages/ForgotPassword";
import ResetPassword from "pages/ResetPassword";
import Home from "pages/Home";
import PrivacyPolicy from "pages/PrivacyPolicy";
import TermsOfService from "pages/TermsOfService";
import Registration from "../pages/Registration";
import NotFound from "../pages/NotFound";
import PrivateRoute from "./PrivateRoute";
import PublicRoute from "./PublicRoute";
import Invetories from "pages/invetory/Invetories";
import Timesheets from "pages/timesheetlist/Timesheets";
import EmployeeList from "pages/employee/EmployeeList";
import Holidays from "pages/holidays/Holidays";
import Leaves from "pages/leaves/Leaves";
import Projects from "pages/project/Projects";
import ProjectDocumentsPage from "pages/project/ProjectDocumentsPage";
import Reimbursement from "pages/reimbursement/Reimbursement";
import ErrorBoundary from "./ErrorBoundry";
import Loader from "components/Loader";
import Profile from "pages/profile";
import Rented from "pages/rentedInventory/Rented";
import SampleInventory from "pages/sampleInventory/SampleInvetory";
import ProtectedRoutes from "layouts/ProtectedRoutes";
import ExportTimeSheet from "pages/exportTimeSheet";
import GenerateDocs from "pages/generate-docs";
import TaskPage from "pages/tasks";
import Register from "pages/register/Registration";
import ReviewList from "pages/feedback/ReviewList";
import TaxConfig from "pages/payrole/taxConfig/TaxConfig";
import Salary from "pages/payrole/salary/Salary";
import SalaryStructureDetails from "pages/payrole/salaryStructure/SalaryStructureDetails";
import SalaryStructureFormPage from "pages/payrole/salaryStructure/SalaryStructureFormPage";
import ViewSalaryStructure from "pages/payrole/salaryStructure/ViewSalaryStructure";
import RouterInfoTab from "pages/OrgSettings/index";
import GeneratePayroll from "pages/payrole/generatePayroll/GeneratePayroll";
import GeneratePayrollRun from "pages/payrole/generatePayroll/GeneratePayrollRun";
// import SalaryList from "pages/payrole/salaryList/SalaryList";
// import Form16 from "pages/payrole/form16/Form16";
// import Form12A from "pages/payrole/form12A/Form12A";
import TrackingDashboard from "pages/tracking/dashboard/TrackingDashboard";
import ShiftConfigurationPage from "pages/shift-config/ShiftConfigurationPage";
import RosterViewPage from "pages/roster/RosterViewPage";
import SalaryDetails from "pages/payrole/salary/SalaryDetails";
import SelectOrganization from "pages/Selectorganization ";
import ModuleProtectedRoute from "./ModuleProtectedRoute";
import AddReimbursement from "pages/reimbursement/AddReimbursement/AddReibmursement";
import AdminConfig from "pages/AdminConfig";
import ModuleConfig from "pages/AdminConfig/ModuleConfig";
import ProjectChatPage from "pages/project/ChatLayout/ProjectChatPage";
import SalaryHistory from "pages/payrole/salaryHistory/SalaryHistory";

// import AdminTrainingPage from "pages/training/admin/AdminTrainingPage";
// import TrainingPreviewPage from "pages/training/admin/TrainingPreviewPage";
import TrainingPreviewPage from "pages/training/admin/TrainingPreviewPage";
import UserTrainingPage from "pages/training/user/UserTrainingPage";
import UserTrainingExecutionPage from "pages/training/user/UserTrainingExecutionPage";
import TrainingDispatcher from "pages/training";
import PlanSelection from "pages/PlanSelection";
import PaymentResultPage from "pages/PaymentResult";
import PendingInvoices from "pages/PendingInvoices";

export default function Routers() {
  return (
    <Suspense fallback={<Loader />}>
      <ErrorBoundary>
        <Router>
          <Routes>
            <Route element={<DefaultLayout />}>
              <Route element={<PublicRoute />}>
                <Route index element={<Home />} />
                <Route path="/login" element={<Login />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/registration" element={<Registration />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/terms-of-service" element={<TermsOfService />} />
                <Route path="/:?token" element={<Login />}></Route>
              </Route>
              <Route path="/payment-result" element={<PaymentResultPage />} />
              <Route path="/plan-selection" element={<PlanSelection />} />
              <Route path="/pending-invoices" element={<PendingInvoices />} />


              <Route path="/drawer" element={<DrawerExample />} />
              <Route path="*" element={<NotFound />} />
            </Route>
            <Route path="/dashboard" element={<Sidebar />} />
            <Route path="/select-organization" element={<SelectOrganization />} />
            <Route
              path="/admin"
              element={<PrivateRoute Layout={AdminLayout} />}
            >
              <Route element={<ModuleProtectedRoute requiredModule="MY_PROFILE" />}>
                <Route path="profile" element={<Profile />} />
              </Route>
              <Route element={<ModuleProtectedRoute requiredModule="TIMESHEETS" />}>
                <Route path="timesheet" element={<Timesheet />} />
                <Route path="timesheets" element={<Timesheets />} />
                <Route path="export-timesheet" element={<ExportTimeSheet />} />
              </Route>
              <Route element={<ModuleProtectedRoute requiredModule="INVENTORY" />}>
                <Route path="rented" element={<Rented />} />
                <Route path="sample" element={<SampleInventory />} />
                <Route path="inventories" element={<Invetories />} />
              </Route>

              <Route path="reimbursement/add" element={<AddReimbursement />} />
              <Route path="admin-config" element={<AdminConfig />} />
              {/* Module settings page (tabs for each sub-config). */}
              <Route path="admin-config/:sectionKey" element={<ModuleConfig />} />
              <Route element={<ModuleProtectedRoute requiredModule="ORG_SETTINGS" />}>
                <Route path="org-settings" element={<RouterInfoTab />} />
              </Route>


              <Route element={<ModuleProtectedRoute requiredModule="REGISTRATION" />}>
                <Route path="register" element={<Register></Register>}></Route>
                <Route path="change-password" element={<ChangePassword />}></Route>
              </Route>

              <Route element={<ModuleProtectedRoute requiredModule="TAX_CONFIG" />}>
                <Route path="taxConfig" element={<TaxConfig></TaxConfig>}></Route>
              </Route>
              <Route element={<ModuleProtectedRoute requiredModule="SALARY_STRUCTURE" />}>
                <Route
                  path="salaryStructure"
                  element={<SalaryStructureDetails />}
                />
                {/* Dedicated Add / Edit / View screens (no modal) */}
                <Route
                  path="salaryStructure/add"
                  element={<SalaryStructureFormPage mode="create" />}
                />
                <Route
                  path="salaryStructure/edit"
                  element={<SalaryStructureFormPage mode="edit" />}
                />
                <Route
                  path="salaryStructure/view"
                  element={<ViewSalaryStructure />}
                />
              </Route>
              {/* <Route path="appraisal" element={<AddAppraisal></AddAppraisal>} /> */}
              <Route element={<ModuleProtectedRoute requiredModule="SALARY" />}>
                <Route path="salary" element={<Salary />} />
                <Route path="salary-list" element={<SalaryDetails />} />
              </Route>

              {/* <Route path="form-16" element={<Form16 />} /> */}
              {/* <Route path="form-12a" element={<Form12A />} /> */}
              <Route element={<ModuleProtectedRoute requiredModule="PROJECT_CHAT" />}>
                <Route path="chat" element={<ProjectChatPage />} />
              </Route>

              <Route path="salary" element={<Salary />} />
              {/* <Route path="salary" element={<SalaryDetails />} /> */}
              <Route path="generate-payroll" element={<GeneratePayroll />} />
              <Route
                path="generate-payroll/run"
                element={<GeneratePayrollRun />}
              />
              <Route path="salary-list" element={<SalaryDetails />} />
              <Route path="salary-history" element={<SalaryHistory />} />
              {/* <Route path="form-16" element={<Form16 />} /> */}
              {/* <Route path="form-12a" element={<Form12A />} /> */}
                {/* <Route path="training" element={<AdminTrainingPage />} /> */}
              {/* admin */}
              <Route element={<ModuleProtectedRoute requiredModule="TRAINING_EXERCISE" />}>

                {/* Main Dispatcher */}
                <Route path="training" element={<TrainingDispatcher />} />

                {/* Admin dedicated preview route */}
                <Route path="training/:id/preview" element={<TrainingPreviewPage />} />

                {/* User dedicated execution route */}
                <Route path="training/:id/execute" element={<UserTrainingExecutionPage />} />

                {/* User dedicated fallback/direct route */}
                <Route path="user/training" element={<UserTrainingPage />} />

              </Route>
              <Route element={<ProtectedRoutes />}>
                <Route element={<ModuleProtectedRoute requiredModule="EMPLOYEES" />}>
                  <Route path="employees" element={<EmployeeList />} />
                </Route>
              </Route>
              <Route element={<ProtectedRoutes allowedRoles={[2, 4]} />}>
                <Route element={<ModuleProtectedRoute requiredModule="PROJECTS" />}>
                  <Route path="projects" element={<Projects />} />
                  <Route path="projects/:projectId/documents" element={<ProjectDocumentsPage />} />
                  <Route path="chat" element={<ProjectChatPage />}  />
                </Route>
              </Route>
              <Route element={<ProtectedRoutes />}>
                <Route element={<ModuleProtectedRoute requiredModule="UPLOAD" />}>
                  <Route path="upload" element={<UploadCsv />} />
                </Route>
              </Route>
              {/* Feedback is accessible to all roles; ReviewList handles role-based content internally */}
              <Route element={<ModuleProtectedRoute requiredModule="FEEDBACK" />}>
                <Route path="feedback" element={<ReviewList />} />
              </Route>
              <Route element={<ModuleProtectedRoute requiredModule="HOLIDAY" />}>
                <Route path="holidays" element={<Holidays />} />
              </Route>
              <Route element={<ModuleProtectedRoute requiredModule="LEAVE" />}>
                <Route path="leaves" element={<Leaves />} />
              </Route>
              {/* <Route element={<ModuleProtectedRoute requiredModule="EMPLOYEE_REVIEW" />}>
                <Route path="review" element={<EmployeeReviews />} />
              </Route> */}
              <Route element={<ModuleProtectedRoute requiredModule="TASKS" />}>
                <Route path="tasks" element={<TaskPage />} />
              </Route>
              <Route element={<ModuleProtectedRoute requiredModule="REIMBURSEMENT" fallbackPath="/admin/profile" />}>
                <Route path="reimbursement" element={<Reimbursement />} />
              </Route>
              <Route element={<ModuleProtectedRoute requiredModule="GENERATE_DOCS" />}>
                <Route path="generate-docs" element={<GenerateDocs />} />
              </Route>
              <Route element={<ModuleProtectedRoute requiredModule="SHIFT_MANAGEMENT" />}>
                <Route
                  path="shift-configuration"
                  element={<ShiftConfigurationPage />}
                />
              </Route>
              <Route element={<ModuleProtectedRoute requiredModule="ROSTER" />}>
                <Route path="roster" element={<RosterViewPage />} />
              </Route>
              {/* <Route path="view-timesheet" element={<ViewTimeSheet />} /> */}
              <Route path="employee-tracking" element={<TrackingDashboard />} />

              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
        </Router>
      </ErrorBoundary>
    </Suspense>
  );
}
